import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import MediaEditor from '../../../components/Editor/MediaEditor';
import { getPageEditableLinksIds } from '../selectors';
import { IndesignMediaElementConfig } from '../utils/indesignEditor/editableMedia/getData';
import { HtmlMediaElementConfig } from '../utils/htmlEditor/editableMedia/getData';

const isPropInData = (prop: string, data: IndesignMediaElementConfig | HtmlMediaElementConfig): boolean => (
	prop in data ? data[prop] : undefined
);

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			type: editorType,
			editableLinks,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
			isAccessibleVersion,
		},
		importManager: { byId },
	} = state;

	if (ownProps.isCustom) {
		return {};
	}

	const { page, editableMediaItem } = ownProps;
	const { id } = editableMediaItem;

	const {
		type,
		frameWidth,
		frameHeight,
		canDragAndResize,
		importManagerId,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
		isVisible,
		isInsideButton,
	} = editableMediaItem;
	const editableLinksIds = getPageEditableLinksIds(state, page);
	const hasLink = editableLinksIds.includes(id);
	const importManagerItem = byId[importManagerId];
	const isProcessingVideo = !!importManagerItem && !!importManagerItem.isProcessing;

	return {
		editorType,
		type,
		frameWidth,
		frameHeight,
		canDragAndResize,
		isActive: id === activeItem.id && page === activeItem.page,
		isEditPanelDisplayed,
		hasLink,
		linkValue: hasLink ?
			editableLinks[page][id].linkData ? editableLinks[page][id].linkData : '' :
			undefined,
		isProcessingVideo,
		isDefaultMedia: isExternalLinkActive ? externalLink === defaultLink : !driveLink,
		frameAspectRatio: isPropInData('frameAspectRatio', editableMediaItem),
		defaultStyle: isPropInData('style', editableMediaItem),
		isVisible,
		isInsideButton,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(MediaEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/MediaEditor/index.tsx